import React, { useState, useRef } from "react";
import { getUUIDInfo } from "../QueryHelper";

export function FileSearchByUUID() {
  const [uuidValue, setUuidValue] = useState("");
  const [oen, setOen] = useState("");
  const [printDate, setPrintDate] = useState("");
  const [fileDetails, setFileDetails] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState();
  const canvasRef = useRef(null)

  const [url, setPdfUrl] = useState("");

  return (
    <form class="bg-white shadow-md rounded  px-8 pt-6 pb-8 mb-4" id="form2">
      <div class="md:flex md:items-center mb-3">
        <div class="w-1/5">

          <label class="block text-gray-500 font-bold md:text-right mb-1 md:mb-5 pr-4" for="inline-uuid">
            Validation Code
          </label>
        </div>
        <input
          class="shadow appearance-none border rounded mb-5 w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
          id="inline-uuid"
          type="text"
          placeholder="aR1CcNbvxKzem1xp9VQCV6"
          onChange={(e) => {
            setUuidValue(e.target.value);
          }}
        />
      </div>
      <div class="md:flex md:items-center mb-3">
        <div class="w-1/5">

          <label class="block text-gray-500 font-bold md:text-right mb-1 md:mb-5 pr-4" for="inline-oen">
            OEN
          </label>
        </div>
        <input
          class="shadow appearance-none border rounded mb-5 w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
          id="inline-oen"
          type="text"
          maxLength={9}
          placeholder="123456789"
          onChange={(e) => {
            setOen(e.target.value);
          }}
        />
      </div>
      <div class="md:flex md:items-center mb-6">
        <div class="w-1/5">
          <label class="block text-gray-500 font-bold md:text-right mb-1 md:mb-5 pr-4" for="inline-print-date">
            Print Date
          </label>
        </div>
        <input
          class="shadow appearance-none border rounded mb-5 w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
          id="inline-print-date"
          type="text"
          placeholder="YYYY-mm-dd"
          onChange={(e) => {
            setPrintDate(e.target.value);
          }}
        />
      </div>
      <button
        className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
        type="button"
        form="form2"
        onClick={async (e) => {
          setError("");
          setSuccess(false);
          setFileDetails("");
          if (uuidValue && oen && printDate) {
            const result = await getUUIDInfo({ uuidValue, oen, printDate, setFileDetails, setError });   
            setPdfUrl(`https://uva-transcripts.s3.amazonaws.com/${result.uuidValue}.pdf`)           
          } else {
            setError("Invalid inputs")
          }
        }}
      >
        Verify Trancript
      </button>
      {fileDetails && (
        <div className="mt-4">
          <p className="mt-4 text-green-600">Validation Code is for a valid transcript. Details:</p>
          <p>Validation Code: {fileDetails.uuidValue}</p>
          <p>OEN: {fileDetails.oen}</p>
          <p>Print Date: {fileDetails.printDate}</p>
          <object  class="w-full h-96" data={url} type='application/pdf' />
        </div>
      )}
      {error && (<p className="mt-4 text-red-600	">{error}</p>)}
    </form>
  );
}
